import PercentageBarLoadingShimmer from "@/reports/components/PercentageBarLoadingShimmer";
import {
  barCss,
  containerCss,
  innerContentCss,
  labelCss,
  valueCss,
} from "./PercentageBarGraph.style";
import ReadingSkillSearchLink from "./ReadingSkillSearchLink";

export enum PercentageBarGraphSize {
  small = "small",
  large = "large",
}
interface PercentageBarGraphProps {
  label?: string | null | undefined;
  value: number | null;
  overrideWithGreen?: {
    bar: boolean;
    label: boolean;
  };
  size?: PercentageBarGraphSize;
  isLoading?: boolean | undefined;
  skillSlug?: string;
  skillName?: string | undefined;
}

const overrideWithGreenDefault = {
  bar: false,
  label: false,
};

const PercentageBarGraph = ({
  label,
  value,
  overrideWithGreen = overrideWithGreenDefault,
  size = PercentageBarGraphSize.small,
  isLoading,
  skillSlug,
  skillName,
}: PercentageBarGraphProps) => {
  if (value === undefined) return <></>;
  const isLargeSize = size === PercentageBarGraphSize.large;
  const isNullValue = value === null;
  const roundedValue = isNullValue ? value : Math.round(value);

  const renderInnerContent = () => {
    if (isLargeSize && isNullValue && skillSlug) {
      return (
        <div css={innerContentCss}>
          <ReadingSkillSearchLink skillSlug={skillSlug} skillName={skillName} />
        </div>
      );
    }
    return <></>;
  };

  return (
    <div css={containerCss(isLargeSize)}>
      <div css={valueCss({ roundedValue, isLargeSize })}>
        {isLoading ? "--%" : roundedValue === null ? "N/A" : `${roundedValue}%`}
      </div>
      <div
        css={barCss({
          roundedValue,
          overrideWithGreen,
          isLargeSize,
          isLoading,
        })}
      >
        {isLoading ? <PercentageBarLoadingShimmer /> : renderInnerContent()}
      </div>
      <div css={labelCss({ roundedValue, overrideWithGreen, isLargeSize })}>
        {label}
      </div>
    </div>
  );
};

export default PercentageBarGraph;
